// 모듈이 Core 생명주기에 끼어들기 위한 훅 레지스트리.
// Core는 모듈을 직접 참조하지 않는다(모듈 경계 규약). 대신 모듈이 여기에 콜백을 등록한다.
// 예) Remote 모듈이 로그아웃 시 채팅 소켓을 정리:  onLogout(chatDisConnect)

const logoutHooks = [];

export function onLogout(fn) {
  logoutHooks.push(fn);
}

export function runLogoutHooks() {
  logoutHooks.forEach((fn) => {
    try {
      fn();
    } catch (e) {
      console.warn("logout hook error", e);
    }
  });
}
